import React from "react";
import style from "./RiskAssessmentScalePanel.module.scss";
import { RiskScale } from "../../Patients/RiskScale";
import { Button } from "../../../primary";

export const RiskAssessmentScalePanel = ({
  score,
  successMessage,
  showNameInput,
  pendingName,
  setPendingName,
  saveAssessmentLoading,
  emailLoading,
  onCancelName,
  onConfirmName,
  onEmailRiskAssessment,
  onSaveRiskAssessment,
}) => {
  return (
    <div>
      <RiskScale scaleType={"braden"} score={score} />

      {successMessage && <div className={style.successBanner}>{successMessage}</div>}

      {showNameInput && (
        <div className={style.nameRow}>
          <div className={style.nameRowField}>
            <label className={style.nameLabel} htmlFor="risk-assessment-name">
              Save risk assessment as
            </label>
            <input
              id="risk-assessment-name"
              className={style.nameInput}
              name="riskAssessmentName"
              type="text"
              autoFocus
              value={pendingName}
              onChange={(e) => setPendingName(e?.target?.value)}
            />
          </div>
          <div className={style.nameRowActions}>
            <Button type="button" classes={{ className: `btn ${style.btn_cancel}` }} onClick={onCancelName}>
              Cancel
            </Button>
            <Button type="button" classes={{ className: `btn ${style.btn_submit}` }} onClick={onConfirmName} disabled={!pendingName}>
              {saveAssessmentLoading && <span className={style.custom_spinner}></span>}
              Save
            </Button>
          </div>
        </div>
      )}

      {!showNameInput && (
        <div className={style.footer}>
          <Button classes={{ className: `btn ${style.btn_cancel}` }} onClick={onEmailRiskAssessment}>
            {emailLoading && <span className={style.custom_spinner}></span>}
            Email Risk Assessment
          </Button>
          <Button classes={{ className: `btn ${style.btn_submit}` }} onClick={onSaveRiskAssessment}>
            {saveAssessmentLoading && <span className={style.custom_spinner}></span>}
            Save Risk Assessment
          </Button>
        </div>
      )}
    </div>
  );
};
